import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";
import ReactQuill, { Quill } from "react-quill";
import { useMainHook } from "../../../../hooks/main";
import { useDiff } from "../../hooks/diffDocuments";

import { useSelection } from "../../hooks/selection";
import { useTextsEdition } from "../../hooks/textsEdition";
import { ButtonDefault } from "../Asidebar/styles";

import {
  FlexContainer,
  NameWrapper,
  WrapperButtons,
  Text,
  NameUser,
  MessageBlockCursor
} from "./styles";
// import { Container } from './styles';

const TextAsideScreen: React.FC = () => {
  const { quillRef, quillRefComponent, isEditing } = useTextsEdition();
  const {
    selectedObject,
    isOpenEdit,
    setIsOpenEdit,
    colorText,
    selectionColor,
    setSelectionColor,
    typeChangeColor,
    setTypeChangeColor
  } = useSelection();
  const {
    myProfileId,
    whichOptionForModal,
    handleOpenModalDifferencesDecline,
    handleOpenModalDifferences
  } = useMainHook();
  const { onBlurQuillText, removeBlur, whichKeyPress, hasGroupShared } =
    useDiff();

  // insert custom button on quill js below when component rendering
  useEffect(() => {
    const divReplace = document.querySelector("span.ql-lineheight");
    let firstChildElementTarget = divReplace.children[0];
    let italicIcon: string = ReactDOMServer.renderToStaticMarkup(
      <img
        src="/images/line-height-rich.svg"
        className="lineHeightRichText"
        alt=""
        width="30px"
        height="22px"
        style={{
          marginLeft: "2rem"
        }}
      />
    );
    // console.log(firstChildElementTarget.children[0], "test");
    //replace icons quill for my design
    let svgObjectChange: any = firstChildElementTarget.children[0];
    svgObjectChange.insertAdjacentHTML("afterend", italicIcon);
    svgObjectChange.remove();
  }, []);

  var icons = Quill.import("ui/icons");
  let italicIcon = ReactDOMServer.renderToStaticMarkup(
    <img src="/images/line-height-rich.svg" alt="" />
  );

  icons["lineheight"] = italicIcon;

  // control for fonts and font size for quill
  let fontFamilyArr = [
    "Roboto",
    "Lato",
    "Montserrat",
    "Open Sans",
    "Verdana",
    "Calibri",
    "Arial",
    "Tahoma",
    "Segoe UI"
  ];
  let Size = Quill.import("attributors/style/size");
  let fonts = Quill.import("attributors/style/font");
  fonts.whitelist = fontFamilyArr;
  Quill.register(fonts, true);
  // let FontAttributor = Quill.import("formats/font");
  // let fonts = ["impact", "courier", "comic"];
  Size.whitelist = [
    "8px",
    "9px",
    "10px",
    "11px",
    "12px",
    "14px",
    "16px",
    "18px",
    "20px",
    "22px",
    "24px",
    "26px",
    "28px",
    "36px",
    "48px"
  ];

  const Inline = Quill.import("blots/inline");
  // This class just adds support for another tag name <strike> in addition to default <s>
  // It is necessary since this tag is used by document.execCommand('strikeThrough')
  class StrikeThroughAlias extends Inline {}
  StrikeThroughAlias.blotName = "strike";
  StrikeThroughAlias.tagName = "strike";
  Quill.register(StrikeThroughAlias);

  Quill.register(Size, true);
  // Quill.register(FontAttributor, true)
  let Parchment = Quill.import("parchment");
  let lineHeightConfig = {
    scope: Parchment.Scope.INLINE,
    whitelist: ["1.0", "1.5", "1.6", "1.8", "2.4", "2.8"]
  };
  let lineHeightClass = new Parchment.Attributor.Class(
    "lineheight",
    "ql-line-height",
    lineHeightConfig
  );
  let lineHeightStyle = new Parchment.Attributor.Style(
    "lineheight",
    "line-height",
    lineHeightConfig
  );
  Parchment.register(lineHeightClass);
  Parchment.register(lineHeightStyle);

  const [position, setPosition] = React.useState({
    isActive: false,
    x: 0,
    y: 0
  });

  const colorsBackgroundMenu = [
    "#FFFFFF",
    "#000",
    "#545454",
    "#737373",
    "#A6A6A6",
    "#D9D9D9",
    "#FF1616",
    "#FF5757",
    "#FF66C4",
    "#CB6CE6",
    "#8C52FF",
    "#5E17EB",
    "#03989E",
    "#00C2CB",
    "#5CE1E6",
    "#38B6FF",
    "#5271FF",
    "#004AAD",
    "#008037",
    "#7ED957",
    "#C9E265",
    "#FFDE59",
    "#FFBD59",
    "#FF914D",
    "custom-color-bg"
  ];

  const modules = React.useMemo(
    () => ({
      toolbar: [
        [{ font: fontFamilyArr }],
        [
          {
            size: [
              "8px",
              "9px",
              "10px",
              "11px",
              "12px",
              "14px",
              "16px",
              "18px",
              "20px",
              "22px",
              "24px",
              "26px",
              "28px",
              "36px",
              "48px"
            ]
          }
        ],

        [
          {
            color: [
              "#FFFFFF",
              "#000",
              "#545454",
              "#737373",
              "#A6A6A6",
              "#D9D9D9",
              "#FF1616",
              "#FF5757",
              "#FF66C4",
              "#CB6CE6",
              "#8C52FF",
              "#5E17EB",
              "#03989E",
              "#00C2CB",
              "#5CE1E6",
              "#38B6FF",
              "#5271FF",
              "#004AAD",
              "#008037",
              "#7ED957",
              "#C9E265",
              "#FFDE59",
              "#FFBD59",
              "#FF914D",
              "custom-color"
            ]
          },
          {
            background: colorsBackgroundMenu
          }
        ],
        ["bold", "italic", "underline", "strike"],
        [{ align: [] }],
        [
          {
            lineheight: ["1.0", "1.5", "1.6", "1.8", "2.4", "2.8"]
          }
        ],
        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" }
        ]
      ],
      clipboard: {
        matchers: [
          [
            Node.ELEMENT_NODE,
            function (node, delta) {
              return delta.compose(
                new Delta().retain(delta.length(), {
                  background: false
                })
              );
            }
          ]
        ]
      },
      keyboard: {
        bindings: {
          list: {
            key: "Delete",
            context: {
              format: ["bold"]
            },
            handler: function (range, context) {
              if (hasGroupShared.current) {
                return false;
              } else {
                return true;
              }
            }
          }
        }
      }
    }),

    []
  );

  var Delta = Quill.import("delta");

  // function strikethrough(node, delta) {
  //   return delta?.compose(
  //     new Delta()?.retain(delta?.length(), { strike: true })
  //   );
  // }

  // formats of rich text register
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "color",
    "background",
    "align",
    "lineheight"
  ];

  const { showButtons, handleDefineModifications, handlePasteQuill } =
    useDiff();

  const divRef = useRef<HTMLDivElement>(null);

  let positionX = divRef.current?.getBoundingClientRect().left;
  let positionY = divRef.current?.getBoundingClientRect().top;

  const [selection, setSelection] = useState<{ index: number; length: number }>(
    {
      index: 0,
      length: 0
    }
  );

  useEffect(() => {
    quillRef.current.getEditor().on("selection-change", range => {
      if (range) {
        if (range.length > 0) {
          setSelectionColor(range);
        }
      }
    });

    quillRef.current
      ?.getEditor()
      ?.getModule("toolbar")
      ?.addHandler("color", value => {
        // if the user clicked the custom-color option,
        // show a prompt window to get the color
        if (value == "custom-color") {
          setTypeChangeColor("color");
          setIsOpenEdit(true);
        } else if (value !== "custom-color") {
          quillRef.current?.getEditor()?.format("color", value);
        }
      });
  }, [quillRef.current]);

  useEffect(() => {
    quillRef.current
      ?.getEditor()
      ?.getModule("toolbar")
      ?.addHandler("background", value => {
        // if the user clicked the custom-color option, show a prompt window to get the color
        if (value == "custom-color-bg") {
          setTypeChangeColor("background");
          setIsOpenEdit(true);
          // value = window.prompt("Insira o hexadecimal para o fundo do texto");
          // quillRef.current?.getEditor()?.format("background", value);
        } else if (value !== "custom-color") {
          quillRef.current?.getEditor()?.format("background", value);
        }
      });
  }, [quillRef.current]);

  const ButtonFinallyDiff: React.FC<{
    title?: string;
    color?: string;
    callback?: () => void;
  }> = ({ title, color, callback }) => {
    return (
      <ButtonDefault color={color} onClick={callback}>
        {title}
      </ButtonDefault>
    );
  };

  const [hideMessage, setHideMessage] = useState(false);

  useEffect(() => {
    if (position.isActive) {
      setTimeout(() => {
        setHideMessage(prevState => !prevState);
      }, 5000);
    } else {
      setHideMessage(false);
    }
  }, [position]);

  return (
    <FlexContainer showButtons={showButtons}>
      {/* disabled quill js when text already edited by other user */}
      {!selectedObject?.attrs?.isModify ? (
        <></>
      ) : (
        selectedObject?.attrs?.idOfUserEdited !== myProfileId && (
          <div
            ref={divRef}
            onClick={event => {
              // setPosition(oldState => {
              //   return {
              //     ...oldState,
              //     isActive: true,
              //     x: event.clientX - positionX,
              //     y: event.clientY - positionY
              //   };
              // });
              return;
            }}
            style={{
              position: "absolute",
              width: "100%",
              height: "100vh",
              marginTop: "6.6rem",
              top: "0",
              background: "transparent",
              opacity: "1",
              zIndex: "999"
              // cursor: `url("${cursorCustom}"), auto`
            }}
          >
            {
              <MessageBlockCursor
                isActive={position.isActive && !hideMessage}
                x={position.x}
                y={position.y}
              >
                <span>Aceite ou rejeite as alterações para editar o texto</span>
              </MessageBlockCursor>
            }
          </div>
        )
      )}

      {showButtons && (
        <WrapperButtons>
          <>
            <ButtonFinallyDiff
              color="#61A861"
              title="Aceitar estas alterações"
              // callback={() => handleDefineModifications("Accept")}
              callback={() => {
                whichOptionForModal.current = "Accept";
                handleOpenModalDifferences("Open");
              }}
              // callback={() => handleOpenModalDiffAccept("Accept")}
            />
            <ButtonFinallyDiff
              color="#E24747"
              title="Rejeitar estas alterações"
              // callback={() => handleDefineModifications("Decline")}
              // callback={() => handleOpenModalDiffAccept("Reject")}
              //force
              callback={() => {
                handleOpenModalDifferencesDecline("Open");
              }}
            />

            <NameWrapper>
              <Text>Alteração feita por:</Text>
              <NameUser> {selectedObject?.attrs?.nameOfUserEdited} </NameUser>
            </NameWrapper>
          </>
        </WrapperButtons>
      )}
      <div className="content-quill">
        <ReactQuill
          ref={quillRef}
          modules={modules}
          // preserveWhitespace
          formats={formats}
          onKeyDown={event => {
            whichKeyPress.current = event.key;
          }}
          onKeyPress={event => {
            whichKeyPress.current = event.key;
          }}
          onKeyUp={event => {
            whichKeyPress.current = event.key;
          }}
          onBlur={(range, source, editor) => {
            setTimeout(() => {
              let fixRange = editor.getSelection();

              if (fixRange) {
                // paste event or none real blur event
                // console.log("real blur");
              } else {
                // console.log("fake blur");
                if (source === "silent") {
                  quillRef.current.getEditor().focus();
                  handlePasteQuill(range);
                } else {
                  return;
                }
              }
            }, 50); // random time
          }}
          theme={"snow"}
          readOnly={
            selectedObject?.attrs?.isModify &&
            selectedObject?.attrs?.idOfUserEdited !== myProfileId
              ? true
              : false
          }
          className="quilljs"
        />
      </div>

      {/* <ButtonSubmitText onClick={handleClickApplyTextEditor}>
        Aplicar
      </ButtonSubmitText> */}
    </FlexContainer>
  );
};

export default TextAsideScreen;
